var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introduce"},[_vm._t("introduce")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }